import { fillArr } from '@hglobal/common';

import { GetUsersByIdsRes } from '../models';

export function getUsersByIds(count = 14): GetUsersByIdsRes {
  return {
    itemsCount: count,
    users: fillArr(count, i => ({
      id: i,
      fullName: 'Aleksander Sidorov',
      imageUrl: 'https://picsum.photos/200?random=2',
      position: 'Head of QA',
      email: `t.biriukov${i}@pin-up.business`,
    })),
  };
}
